export function formatDistance(meters: number | null): string | null {
  if (meters === null || meters === 0) {
    return null;
  }

  if (meters < 1000) {
    return `${Math.round(meters)} m`;
  }

  return `${(meters / 1000).toFixed(1)} km`;
}

export function formatDuration(seconds: number | null): string | null {
  if (seconds === null || seconds === 0) {
    return null;
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }

  if (minutes > 0) {
    return `${minutes}m`;
  }

  return `${secs}s`;
}

export function formatPace(
  meters: number | null,
  seconds: number | null,
  unit: "km" | "100m" = "km",
): string | null {
  if (meters === null || seconds === null || meters === 0) {
    return null;
  }

  const divisor = unit === "km" ? 1000 : 100;
  const paceSeconds = seconds / (meters / divisor);
  const paceMinutes = Math.floor(paceSeconds / 60);
  const paceRemainder = Math.floor(paceSeconds % 60);

  const label = unit === "km" ? "/km" : "/100m";
  return `${paceMinutes}:${paceRemainder.toString().padStart(2, "0")} ${label}`;
}

export function formatSpeed(metersPerSecond: number | null): string | null {
  if (metersPerSecond === null || metersPerSecond === 0) {
    return null;
  }

  return `${(metersPerSecond * 3.6).toFixed(1)} km/h`;
}

export function formatHeartRate(bpm: number | null): string | null {
  if (bpm === null) {
    return null;
  }

  return `${Math.round(bpm)} bpm`;
}

export function formatElevation(meters: number | null): string | null {
  if (meters === null) {
    return null;
  }

  return `+${Math.round(meters)} m`;
}

export function formatPower(watts: number | null): string | null {
  if (watts === null) {
    return null;
  }

  return `${Math.round(watts)} W`;
}

export function formatCalories(cal: number | null): string | null {
  if (cal === null) {
    return null;
  }

  return `${Math.round(cal)} kcal`;
}

export function formatCadence(spm: number | null): string | null {
  if (spm === null) {
    return null;
  }

  return `${Math.round(spm)} spm`;
}
